import type { LeadHistoryAutomation } from '@/api/types/crm/crm.types'

/** Суффикс бэка: (выполнено автоматизацией «…») — убираем, если рисуем бейдж. */
const AUTOMATION_DESC_SUFFIX_RE =
  /\s*\(выполнено автоматизацией\s*[«"'].*?[»"']\)\s*$/i

export const getLeadHistoryAutomation = (
  automation: LeadHistoryAutomation | null | undefined,
): LeadHistoryAutomation | null => {
  if (!automation || typeof automation !== 'object') return null
  return automation
}

export const stripAutomationDescriptionSuffix = (
  text: string | null | undefined,
): string => {
  if (typeof text !== 'string') return ''
  return text.replace(AUTOMATION_DESC_SUFFIX_RE, '').trim()
}

export const getAutomationActionTypeLabel = (
  actionType?: string | null,
  multipleDealsEnabled = true,
): string => {
  switch (String(actionType || '')) {
    case 'set_field_value':
    case 'append_field_value':
    case 'set_datetime_offset':
      return 'Изменение поля'
    case 'set_status':
      return 'Смена статуса'
    case 'assign_manager':
      return 'Назначение менеджера'
    case 'create_task':
      return 'Создание задачи'
    case 'create_deal':
    case 'add_to_funnel':
      return multipleDealsEnabled
        ? 'Создание / добавление сделки'
        : 'Добавление в воронку'
    default:
      return 'Действие автоматизации'
  }
}

export const getAutomationRuleDisplayName = (
  automation: LeadHistoryAutomation,
): string => {
  const name = String(automation.name ?? '').trim()
  return name || 'Автоматизация'
}
